import React, { useCallback } from 'react';

import * as fromProjects from 'store/Projects';

import { Image } from "./Image";

import { useIntersect } from 'hooks/useIntersect';

interface IProps {
  animationReady: boolean;
  content: fromProjects.IContentMassiveScrollingImages;
}

export const AngledHorizontal: React.FC<IProps> = ({ animationReady, content, ...props }) => {
  const rotationAngleDegrees = content.angle;
  const rotationAngleRadians = rotationAngleDegrees * Math.PI / 180;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const gapStyles = {
    marginTop: `calc(   (  -100% * ${Math.tan(rotationAngleRadians)}  )    )`,
  };

  const endGapStyles = {
    paddingBottom: `calc(   (  100% * ${Math.tan(rotationAngleRadians)}  )    )`,
  };

  const getImages = useCallback(() => (
    content.images.map((image, index) => (
      <Image key={index} index={index} animationReady={inView} angle={content.angle} image={image} />
    ))
  ), [inView]);

  return (
    <div ref={inViewRef} className='imagesWrapper'>
      <div className='negativeMargin'>
        <div style={gapStyles} />
      </div>
      {getImages()}
      <div className='negativeMargin'>
        <div style={endGapStyles} />
      </div>
    </div>
  );
};
